import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  private supabase = inject(SupabaseService);

  getSubscriptionData(companyId: number): Observable<any> {
    return from(
      this.supabase.client.rpc('get_subscription_data', {
        p_company_id: companyId
      })
    ).pipe(
      map(response => {
        if (response.error) throw response.error;
        return response.data;
      })
    );
  }

  getSubscriptionPlans(): Observable<any[]> {
    return from(
      this.supabase.client.from('subscription_plans_tb').select('*')
    ).pipe(
      map(response => {
        if (response.error) throw response.error;
        return response.data || [];
      })
    );
  }

  getPaymentHistory(companyId: number, limit: number = 20, offset: number = 0): Observable<any> {
    return from(
      this.supabase.client.rpc('get_subscription_payment_history', {
        p_company_id: companyId,
        p_limit: limit,
        p_offset: offset
      })
    ).pipe(
      map(response => {
        if (response.error) throw response.error;
        return response.data;
      })
    );
  }
}
